import type { TkDict } from "./types";

const dict: TkDict = {
  uz: {
    "tk.pages.crumbs_label": "Sahifa yo'li",
    "tk.pages.privacy.title_1": "Maxfiylik",
    "tk.pages.privacy.title_2": "siyosati",
    "tk.pages.terms.title_1": "Foydalanish",
    "tk.pages.terms.title_2": "shartlari",
    "tk.pages.notfound.title_1": "Sahifa",
    "tk.pages.notfound.title_2": "topilmadi",
  },
  ru: {
    "tk.pages.crumbs_label": "Навигационная цепочка",
    "tk.pages.privacy.title_1": "Политика",
    "tk.pages.privacy.title_2": "конфиденциальности",
    "tk.pages.terms.title_1": "Условия",
    "tk.pages.terms.title_2": "использования",
    "tk.pages.notfound.title_1": "Страница",
    "tk.pages.notfound.title_2": "не найдена",
  },
  en: {
    "tk.pages.crumbs_label": "Breadcrumb",
    "tk.pages.privacy.title_1": "Privacy",
    "tk.pages.privacy.title_2": "Policy",
    "tk.pages.terms.title_1": "Terms of",
    "tk.pages.terms.title_2": "Service",
    "tk.pages.notfound.title_1": "Page",
    "tk.pages.notfound.title_2": "not found",
  },
};

export default dict;
